import { harvestiqEmailAddress } from '@harvestiq/constants';

type EmailLinkProps = {
  email?: string | null;
  className?: string;
};

const EmailLink = ({
  email = harvestiqEmailAddress,
  className,
}: EmailLinkProps) => {
  return (
    <a
      href={`mailto:${email}`}
      target="_blank"
      rel="noreferrer"
      className={className}
    >
      {email}
    </a>
  );
};

export default EmailLink;
